import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { SellerManagementService } from '../../../service/seller-management.service';

@Component({
  selector: 'app-product-category-config',
  templateUrl: './product-category-config.component.html',
  styleUrls: ['./product-category-config.component.scss']
})
export class ProductCategoryConfigComponent implements OnInit {
  id: string = ''; businessId = ''; lstSectionConfigKeys: string[] = ["product_categories"];
  @Input() languageContents: any = null; message: string = ''; isRedAlert: boolean = true; 
  htmlId: string = '';  elementIds: any;
  @Output() languageContentsChange = new EventEmitter<any>();

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private activeModal: NgbActiveModal, private sellerManagementService: SellerManagementService) { 
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      name: 'product_cate_' + this.htmlId,
      first_name: 'product_cate_' + this.htmlId + '_m'
    };
  }

  
  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  onLoad() {
    if (this.id != '') {
      this.sellerManagementService.getProductCategory(this.id).subscribe(result => {
        this.languageContents = result;
      });
    }
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    if (this.doCheck()) {
      if (this.id != '') {
        this.sellerManagementService.updateProductCategory(this.id, this.languageContents).subscribe(result => {
          if (result == Status.Success) {
            this.activeModal.close({ event: TriggeredEvent.Ok });
          }
        });
      } else {
        this.sellerManagementService.addProductCategory(this.businessId, this.languageContents).subscribe(result => {
          if (result.status == Status.Success) {
            this.activeModal.close({ event: TriggeredEvent.Ok, id: result.id });
          }
        });
      }
    }
  }

  onEmptyLanguageContainerAdded(languageContents: any) {
    this.languageContents = languageContents;
  }

  doCheck() {
    let message = '';
    this.isRedAlert = true;
    if (!this.languageContents || this.languageContents.filter(x => x.v3 != '').length == 0) {
      message = this.localService.languageContent.product_categories.need_name;
      this.localService.onFocusNextInput(this.elementIds.first_name, FocusInputType.TextBox);
    }
    this.message = message;
    return message == '';
  }
}
